<!--<i18n>
  {
  "en": {
  "title": "Example Application"
  },
  "tr": {
  "title": "Örnek Uygulama"
  }
  }
</i18n>-->

<template>
  <div class="site-header">
    <router-link to="/" class="logo">
      <img src="static/logo.png">
      <h1>Biyogaz Hesaplama</h1>
    </router-link>
    <div class="select-language">
      <img src="static/earth.svg">
      <select v-model="siteLang">
        <option v-for="(lang, index) in langSupport" :val="lang" :key="index">{{ lang }}</option>
      </select>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  export default {
    name: 'AppHeader',
    data () {
      return {
        siteLang: ''
      }
    },
    mounted () {
      this.siteLang = this.langDefault
    },
    watch: {
      siteLang () {
        const payload = {
          lang: this.siteLang,
          app: this
        }
        this.$store.commit('i18n/LANG_CHANGE', payload, { root: true })
      }
    },
    computed: {
      ...mapGetters('i18n', [
        'langDefault',
        'langSupport'
      ])
    }
  }
</script>

<style lang="scss" scoped>
  .site-header {
    background-color: #fff;
    padding: 20px 30px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .logo {
      h1 {
        font-size: 16px;
        margin-top: 5px;
      }
    }
    .select-language {
      color: $color-primary;
      display: flex;
      align-items: center;
      img {
        width: 24px;
        margin-right: 10px;
      }
      select {
        *background: #fff;
        -webkit-appearance: none;
        -moz-appearance: none;
        border: none;
        text-transform: uppercase;
        font-size: 14px;
        font-weight: bold;
        color: $color-primary;
        outline: 0;
      }
    }
    @media only screen and (max-width: 768px) {
      border-bottom: 1px solid #f3f3f3;
      .logo {
        img {
          width: 100px;
          height: auto;
        }
        h1 {
          font-size: 13px;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/view/global/app-header/index.vue